import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { pageHead } from "@/lib/seo";
import { softwareApplicationSchema } from "@/utils/schema";

export const Route = createFileRoute("/zh/")({
  head: () => ({
    ...pageHead("/", "zh"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(softwareApplicationSchema),
      },
    ],
  }),
  component: Index,
});
